import { Container } from "react-bootstrap";

const CandidateHeader = () => {
  return (
    <div className="bg-primary py-2 mb-5">
      <Container>
        <h3 className="text-white">Top Jobs</h3>
      </Container>
    </div>
  )
}

export default CandidateHeader;